import s from "../../common.module.css";
import { getInArr } from "@/helpers/getInArr";
import { jsonConvert } from "@/helpers/jsonConvert";
import { useMemo } from "react";
import Task, { TaskBalls } from "../../../Task";

export const Comment = (props) => {
  const state = props.state;

  // получаем задания
  const allTasks = state?.probeTasks?.map((i) => i.task);

  const tasks = allTasks?.filter((item) => !getInArr(item.type, ["file-answer"]));
  const cPath = allTasks?.filter((item) => getInArr(item.type, ["file-answer"]));

  const initAnswer = () => {
    const arr = {};
    state?.probeTasks?.forEach(
      (task) => (arr[task.task_id] = { score: "" })
    );
    state?.probeWorkResults?.forEach(({ task_id, score }) => {
      arr[task_id] = { score: score ?? "" };
    });
    return arr;
  };
  
  const answer = useMemo(() => initAnswer(), [state]);

  // получение максимума баллов за тестовую часть
  const checkMaxBallTestPath = () => {
    let maxBalls = 0;
    if (answer !== null)
      tasks?.forEach((item) => {
        const weight = typeof item.exam_weight === 'object' ? 
          item.exam_weight?.slice(-1) 
          : jsonConvert(item.exam_weight)?.slice(-1)
        if (weight?.length) maxBalls += weight[0]?.score;
      });
    return maxBalls;
  };
  // получение баллов за тестовую часть
  const checkBallTestPath = () => {
    let sumBalls = 0;
    if (answer !== null)
      tasks?.forEach((item) => {
        const weight = answer[item.id]?.score;
        if (weight) sumBalls += weight;
      });
    return sumBalls;
  };

  // получение максимума баллов за С часть
  const checkMaxBallCPath = () => {
    let maxBalls = 0;
    cPath?.forEach((item) => {
      const weight = typeof item.exam_weight === 'object' ? 
        item.exam_weight?.slice(-1) 
        : jsonConvert(item.exam_weight)?.slice(-1)

      if (weight?.length) maxBalls += weight[0]?.score;
    });
    return maxBalls;
  };

  // получение баллов за С часть
  const checkBallCPath = () => {
    let sumBalls = 0;
    if (answer !== null)
      cPath?.forEach((item) => {
        const weight = answer[item.id]?.score;
        if (weight) sumBalls += weight;
      });
    return sumBalls;
  };

  // получение процента решенных задач
  const checkCountSolved = () => {
    const totalCount = state?.probeTasks?.length;
    let solvedCount = 0;
    if (answer !== null)
      for (let key in answer) {
        if (answer[key]?.score > 0) solvedCount++;
      }
    return Math.round((solvedCount / totalCount) * 100);
  };

  const maxBallTestPath = useMemo(
    () => (tasks?.length ? checkMaxBallTestPath() : 0),
    [tasks]
  );
  const ballTestPath = checkBallTestPath();

  const maxBallCPath = useMemo(
    () => (cPath?.length ? checkMaxBallCPath() : 0),
    [cPath]
  );
  const ballCPath = checkBallCPath();

  const countSolved =
    props.state.decided_right !== undefined
      ? props.state.decided_right
      : checkCountSolved();

  return (
    <>
      {state.id !== undefined ? (
        <div className={s.commentList}>
          <div className={s.balls}>
            <TaskBalls
              title="Тестовая часть"
              val={ballTestPath}
              maxVal={maxBallTestPath}
            />
          </div>
          {tasks?.map((el, idx) => (
            <Task
              key={el.id}
              {...{
                props: { ...el, category: "decided" },
                title: idx + 1,
                result: state.probeWorkResults?.find((i) => +i.task_id === el.id),
                status: state.status,
              }}
            />
          ))}

          <div className={s.balls}>
            <TaskBalls title="C часть" val={ballCPath} maxVal={maxBallCPath} />
          </div>

          {cPath?.map((el, idx) => {
            return(
               <Task
                  key={el.id}
                  {...{
                    props: { ...el, category: "decided" },
                    title: idx + 1,
                    result: state.probeWorkResults?.find((i) => +i.task_id === el?.id),
                    status: state.status,
                  }}
                />
            )
          })}

          <div className={s.balls}>
            <TaskBalls 
              title="Итого"
              val={ballTestPath + ballCPath}
              maxVal={countSolved}
              maxValTitle="Итоговые баллы"
            />
          </div>

          {props?.state?.comment && (
            <div className={s.card}>
              <h2 className={s.cardTitle}>Комментарий к пробнику</h2>

              <p>{props?.state?.comment}</p>
            </div>
          )}
        </div>
      ) : (
        <h2>Нет данных</h2>
      )}
    </>
  );
};